import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../pages/login/auth.service';
import { LoggingService } from 'src/app/services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class AutoLoginGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canLoad(): Observable<boolean> {
    return this.authService.isAuthenticated.pipe(
      filter((val) => val !== null), // Filter out initial Behaviour subject value
      take(1), // Otherwise the Observable doesn't complete!
      map((isAuthenticated) => {
        LoggingService.log('Found previous token, automatic login');
        if (isAuthenticated) {
          // Directly open inside area
          this.router.navigateByUrl('/dashboard', { replaceUrl: true });
          return false;
        } else {
          // Simply allow access to the login
          return true;
        }
      }),
    );
  }
}
